import React from 'react';

export interface SMSTemplate {
  id: string;
  name: string;
  description: string;
  content: string;
  thumbnail: string;
}

export const smsTemplates: SMSTemplate[] = [
  {
    id: 'welcome',
    name: 'Welcome Message',
    description: 'Welcome new customers to your business',
    thumbnail: '👋',
    content: "Welcome to {{businessName}}, {{firstName}}! We're thrilled to have you join us. If you have any questions, please reply to this message or call us at {{businessPhone}}. Thank you!"
  },
  {
    id: 'promotion',
    name: 'Special Offer',
    description: 'Send promotional offers and discounts',
    thumbnail: '🎁',
    content: "{{firstName}}, enjoy [[discount]] off your next purchase at {{businessName}}! Use code [[code]] at checkout. Valid until [[expiryDate]]. T&Cs apply."
  },
  {
    id: 'reminder',
    name: 'Appointment Reminder',
    description: 'Remind customers of upcoming appointments',
    thumbnail: '📅',
    content: "Hi {{firstName}}, this is a reminder about your appointment with {{businessName}} on [[date]] at [[time]]. Reply Y to confirm or call {{businessPhone}} to reschedule."
  }
];

const SMSTemplates = () => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      {smsTemplates.map((template) => (
        <div key={template.id} className="border rounded-lg p-4 hover:border-primary cursor-pointer">
          <div className="text-4xl mb-2">{template.thumbnail}</div>
          <h3 className="font-medium">{template.name}</h3>
          <p className="text-sm text-muted-foreground">{template.description}</p>
        </div>
      ))}
    </div>
  );
};

export default SMSTemplates; 